import React, { memo } from 'react';
const pillItems = ['Better portraits', 'Better action shots', 'Better phone photos', 'More natural expressions', 'More meaningful memories', 'Beginner-friendly guidance', 'Cleaner composition', 'More confidence with your phone'];
const testimonials = [{
  initials: 'EP',
  name: 'Emily P.',
  location: 'Auckland',
  role: 'Dog Mom',
  quote: 'I used to take loads of photos and still keep almost none. Now I finally know how to capture my dog in a way that actually feels special.'
}, {
  initials: 'LR',
  name: 'Liam R.',
  location: 'Wellington',
  role: 'Dog Owner',
  quote: 'My dog finally looks in photos the way she feels in real life. That alone made this worth it.'
}, {
  initials: 'SC',
  name: 'Sophie C.',
  location: 'Christchurch',
  role: 'Puppy Owner',
  quote: 'The tips are simple, practical, and easy to apply with a phone. I saw a difference almost immediately.'
}, {
  initials: 'PA',
  name: 'Piper A.',
  location: 'Hamilton',
  role: 'Dog Lover',
  quote: 'I wanted better memories of my dog, not just random snapshots. This made everything feel much easier and more intentional.'
}];
export function TestimonialsSection() {
  return <section className="bg-warm-light py-16 md:py-24 px-4" data-id="element-378">
      <div className="max-w-3xl mx-auto" data-id="element-379">
        {/* Mini heading + pills */}
        <p className="font-sans text-sm md:text-base font-bold text-center text-warm-hero uppercase tracking-wider mb-5" data-id="element-380">
          ✅ THE MEGAPACK HELPS YOU:
        </p>

        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-2.5 mb-14 md:mb-16" data-id="element-381">
          {pillItems.map(item => <span key={item} className="font-sans text-[12px] md:text-sm font-medium text-gray-700 border border-soft-gold/30 rounded-full px-3.5 py-1.5 bg-white shadow-sm" data-id="element-382">
              {item}
            </span>)}
        </div>

        {/* Main heading */}
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-center text-warm-hero mb-12 leading-tight" data-id="element-383">
          🐾 REAL DOG OWNERS.{' '}
          <span className="italic text-soft-gold" data-id="element-384">REAL RESULTS.</span>
        </h2>

        {/* Testimonials */}
        <div className="space-y-6" data-id="element-385">
          {testimonials.map((t, index) => <div key={index} className="bg-white p-6 md:p-8 rounded-xl border border-soft-gold/10 shadow-sm relative" data-id="element-386">
              {/* Quote mark */}
              <div className="text-soft-gold text-5xl absolute top-3 left-5 opacity-15 font-serif leading-none" data-id="element-387">
                "
              </div>

              {/* Reviewer info */}
              <div className="flex items-center gap-3 mb-3" data-id="element-388">
                <div className="w-10 h-10 rounded-full bg-soft-gold/20 text-dark-gold flex items-center justify-center font-bold font-sans flex-shrink-0 text-sm" data-id="element-389">
                  {t.initials}
                </div>
                <div data-id="element-390">
                  {/* Stars */}
                  <div className="flex text-orange text-sm mb-0.5" data-id="element-391">
                    {'★★★★★'.split('').map((star, i) => <span key={i} data-id="element-392">{star}</span>)}
                  </div>
                  <p className="font-sans text-sm text-gray-500 font-medium" data-id="element-393">
                    {t.name} · {t.location} · {t.role}
                  </p>
                </div>
              </div>

              {/* Quote */}
              <p className="font-sans text-base md:text-lg text-gray-800 italic mb-0 relative z-10 leading-relaxed" data-id="element-394">
                "{t.quote}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}